// @flow
import { connect } from 'react-redux'
import Previews from './Previews'
import type { Store } from '../../redux/ducks'
import type { PreviewData } from '../AdEdit/NamedPreview'
import _ from 'lodash'
import { VK_PUBLIC, FB_PUBLIC } from '../FreeService'
import { getMedia } from '../../redux/selectors'
import { extractDomainFromUrl } from '../AdEdit/ProviderPreviews/prepareDataForPreview'
import type { AdvertisementTemplateAudienceData } from '../../redux/ducks/advertisementTemplate/reducers'
import { calculateTag, selectPreviews } from '../AdEdit/ProviderPreviews/TagSwitcher'

function mapStateToProps(state: Store) {
  const data = state.advertisementTemplate
  const previewData: Array<PreviewData> = _.map(data.media, (media) => {
    const imageStoreId = media.columnImageStoreId || media.multiImageStoreId
    const image = (imageStoreId && getMedia(state, imageStoreId): any)
    const video = (media.videoStoreId && getMedia(state, media.videoStoreId): any)
    const logoImage = (data.common.logoImageStoreId &&
      getMedia(state, data.common.logoImageStoreId): any)
    const tmSmallImage = (media.tmSmallImageStoreId &&
      getMedia(state, media.tmSmallImageStoreId): any)
    const fbInstagramImage = (media.fbInstagramImageStoreId &&
      getMedia(state, media.fbInstagramImageStoreId): any)
    const fbThumbnailImage = (media.fbThumbnailImageStoreId &&
      getMedia(state, media.fbThumbnailImageStoreId): any)
    const vkBigImage = (media.vkBigImageStoreId && getMedia(state, media.vkBigImageStoreId): any)

    return {
      url: extractDomainFromUrl(data.common.url),
      title: data.common.title,
      vkTitle: data.common.vkTitle,
      fbTitle: data.common.fbTitle,
      description: data.common.columnDescription || data.common.multiDescription,
      vkExtendedDescription:
        data.common.vkMultiDescription || data.common.vkWithoutButtonDescription,
      fbExtendedDescription: data.common.fbMultiDescription,
      image: image,
      vkImageCrop:
        media.vkColumnImageCrop ||
        media.vkMultiImageCrop ||
        media.vkArticleImageCrop ||
        media.vkSiteImageCrop,
      tmImageCrop: media.tmColumnImageCrop || media.tmMultiImageCrop,
      fbImageCrop: media.fbImageCrop,
      glImageCrop: media.glImageCrop,
      linkTitle: data.common.vkLinkTitle,
      logoImage: logoImage,
      logoImageCrop: data.common.logoImageCrop,
      vkPublic: VK_PUBLIC,
      fbPublic: FB_PUBLIC,
      video: video,
      vkHasButton: true,
      tmSmallImage: tmSmallImage,
      tmSmallImageCrop: media.tmSmallImageCrop,
      tmLinkButton: data.common.tmLinkButton || '',
      instagramImage: fbInstagramImage,
      instagramImageCrop: media.fbInstagramImageCrop,
      fbLinkButton: data.common.fbLinkButton || '',
      vkLinkButton: data.common.vkLinkButton || '',
      fbThumbnailImage: fbThumbnailImage,
      fbThumbnailImageCrop: media.fbThumbnailImageCrop,
      vkBigImage: vkBigImage
    }
  })

  return {
    previewNames: previewNamesFromAudiences(state),
    previewData: previewData
  }
}

function previewNamesFromAudiences(storeState: Store): Array<string> {
  const data = storeState.advertisementTemplate

  if (!data) return []
  const selectedAudiences = _.filter(
    data.audiences,
    (audience: AdvertisementTemplateAudienceData) =>
      _.includes(storeState.audiencesSelector.ids, audience.id)
  )

  return _.sortBy(
    _.uniq(
      _.flatMap(selectedAudiences, (audience: AdvertisementTemplateAudienceData) => {
        return selectPreviews({
          providers: audience.providers,
          tags: [calculateTag(audience.audienceType, audience.placementType)],
          fbPlacements: audience.fbPlacements
        })
      })
    )
  )
}

const PreviewsContainer = connect<Object, Object, _, _, _, _>(mapStateToProps)(Previews)

export default PreviewsContainer
